/* eslint-disable react/display-name */
import React from "react";
import { useSelected, useFocused } from "slate-react";
import * as palette from "@govlaunch/palette";

const Image = ({ attributes, children, element, style }) => {
  const selected = useSelected();
  const focused = useFocused();

  return (
    <div {...attributes} style={parseImageStyle(element, style)}>
      {children}
      <div contentEditable={false}>
        <img
          src={element.url}
          alt={element.alt}
          css={{
            width: element.width ? `${element.width}px` : "100%",
            height: element.height ? `${element.height}px` : undefined,
            boxShadow: selected && focused ? `0 0 0 3px ${palette.sealBlue}` : "none",
          }}
        />
      </div>
    </div>
  );
};

function parseImageStyle(element, style) {
  if (!element.align) {
    return {
      ...style,
    };
  }

  return {
    display: "flex",
    flexDirection: "column",
    alignItems: parseAlignment(element.align),
    ...style,
  };
}

function parseAlignment(align) {
  if (align === "left") {
    return "start";
  }

  if (align === "right") {
    return "end";
  }

  return align;
}
export default Image;
